/** Diversification group parameters (plan §3.3 · F11). */
export const DIVERSIFICATION_GROUP_SIZE = 4;
export const INVERSE_THRESHOLD = -0.05;
export const SIMILAR_THRESHOLD = 0.45;
export const SECTOR_DIVERSIFIER_PANEL = 7;
